export default __webpack_public_path__ + "static/media/road-map-bottom-1.7dc6b98a.png";